module.exports = __webpack_public_path__ + "media/images/expert__selectedArrow-9519cf4ad7d08618a7b1a36ad271d45c.png";